var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDiagSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m227.5-188.08-39.42-39.42 448.15-448.46H355.65v-55.96h375.96v375.96h-55.96v-280.77L227.5-188.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDiagSvg);
export default __webpack_public_path__ + "static/media/arrow_diag_svg.fa5e33acfae76fa521ad7cae40f5023c.svg";
export { ForwardRef as ReactComponent };